export const skiCupInfo = [
  {
    id: "general-recommendations",
    title: "Recomendaciones Generales",
    type: "section",
    items: [
      {
        type: "recommendation",
        text: "Utilizar ropa térmica en capas (base layer, mid layer, outer shell)."
      },
      {
        type: "recommendation",
        text: "No olvidar lentes con protección UV, bloqueador solar y lip balm."
      },
      {
        type: "recommendation",
        text: "Mantenerse hidratado constantemente, incluso con frío."
      },
      {
        type: "safety",
        text: "Respetar siempre la señalización y niveles de pista."
      },
      {
        type: "advice",
        text: "Si no tienes experiencia avanzada, considera una clase inicial con instructor certificado."
      },
      {
        type: "requirement",
        text: "Revisar previamente tu equipo (botas bien ajustadas, casco obligatorio)."
      }
    ]
  },

  {
    id: "insurance-coverage",
    title: "Seguro Internacional y Cobertura",
    type: "section",
    items: [
      {
        type: "coverage",
        highlight: true,
        text: "Contamos con cobertura de emergencias en montaña dentro del resort."
      },
      {
        type: "warning",
        text: "Aplica únicamente para emergencias en pista."
      },
      {
        type: "warning",
        text: "No sustituye un seguro médico internacional integral."
      },
      {
        type: "action-group",
        title: "Recomendamos contactar a su broker o aseguradora para:",
        subItems: [
          {
            type: "action",
            text: "Extender su póliza de gastos médicos de forma internacional."
          },
          {
            type: "action",
            text: "Verificar cobertura específica para deportes de invierno / ski."
          },
          {
            type: "action",
            text: "Confirmar montos de cobertura, deducibles y repatriación médica."
          }
        ]
      },
      {
        type: "benefit",
        text: "Brinda tranquilidad adicional ante eventualidades fuera de la montaña o durante el viaje."
      }
    ]
  },

  {
    id: "recommended-clothing",
    title: "Vestimenta Recomendada",
    type: "section",
    items: [
      {
        type: "system",
        title: "Sistema de Capas",
        subItems: [
          {
            id: "base-layer",
            title: "Primera capa (Base Layer)",
            type: "layer",
            details: [
              "Ropa térmica ajustada (superior e inferior).",
              "Material sintético o lana merino.",
              "Evitar algodón (retiene humedad).",
              "Función: mantener el cuerpo seco y regular temperatura."
            ]
          },
          {
            id: "mid-layer",
            title: "Segunda capa (Mid Layer)",
            type: "layer",
            details: [
              "Fleece, sudadera térmica o chamarra ligera acolchada.",
              "Función: conservar el calor corporal.",
              "Ajustar grosor según tolerancia al frío."
            ]
          },
          {
            id: "outer-shell",
            title: "Capa exterior (Outer Shell)",
            type: "layer",
            details: [
              "Chamarra y pantalón impermeables (waterproof y windproof).",
              "Tecnología respirable recomendada: 10k–20k mm.",
              "Función: proteger contra nieve, viento y humedad."
            ]
          }
        ]
      },
      {
        type: "essential-list",
        title: "Accesorios Indispensables",
        items: [
          "Goggles con protección UV.",
          "Guantes impermeables.",
          "Buff o cuello térmico.",
          "Calcetas largas especiales para ski/snowboard (no usar doble calceta)."
        ],
        meta: {
          note: "Disponibles en tiendas cercanas al hotel."
        }
      },
      {
        type: "additional-recommendations",
        title: "Recomendaciones Adicionales",
        items: [
          "Bloqueador solar FPS 50.",
          "Protector labial con UV.",
          "Mantenerse hidratado.",
          "Evitar prendas demasiado ajustadas.",
          "Para snowboard principiantes: protección ligera en rodillas y muñecas."
        ]
      }
    ]
  }
];
